/**
 * @generated SignedSource<<376321435d00449d08088a78f8a441da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveFavoriteMutationInput = {
  campaignId: string;
  clientMutationId?: string | null;
};
export type FavoriteButtonRemoveMutation$variables = {
  connections: ReadonlyArray<string>;
  input: RemoveFavoriteMutationInput;
};
export type FavoriteButtonRemoveMutation$data = {
  readonly removeFavorite: {
    readonly __typename: "RemoveFavoriteError";
    readonly message: string;
  } | {
    readonly __typename: "RemoveFavoriteSuccess";
    readonly campaign: {
      readonly isFavoriteCheck: boolean;
    };
    readonly favorite: {
      readonly id: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type FavoriteButtonRemoveMutation = {
  response: FavoriteButtonRemoveMutation$data;
  variables: FavoriteButtonRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavoriteCheck",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "RemoveFavoriteError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FavoriteButtonRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeFavorite",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Campaign",
                "kind": "LinkedField",
                "name": "campaign",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Favorite",
                "kind": "LinkedField",
                "name": "favorite",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "RemoveFavoriteSuccess",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FavoriteButtonRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeFavorite",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Campaign",
                "kind": "LinkedField",
                "name": "campaign",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Favorite",
                "kind": "LinkedField",
                "name": "favorite",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "id",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RemoveFavoriteSuccess",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "904413e0ec88372f36cfc937852ada2d",
    "id": null,
    "metadata": {},
    "name": "FavoriteButtonRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation FavoriteButtonRemoveMutation(\n  $input: RemoveFavoriteMutationInput!\n) {\n  removeFavorite(input: $input) {\n    __typename\n    ... on RemoveFavoriteSuccess {\n      campaign {\n        isFavoriteCheck\n        id\n      }\n      favorite {\n        id\n      }\n    }\n    ... on RemoveFavoriteError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "17e6183897926a1fd37659536c183d5c";

export default node;
